import { z } from "zod";

import { assetSchema } from "./asset";
import { productSchema } from "./product";

export const assetSearchOutputSchema = z.object({
  assets: z
    .array(
      assetSchema.pick({
        name: true,
        url: true,
        type: true,
        width: true,
        height: true,
        embeddingText: true,
        tags: true,
      }),
    )
    .optional(),
});

export const editOutputSchema = z.object({
  editResult: z.string().optional(),
});

export const staticAnalysisOutputSchema = z.object({
  staticAnalysisResult: z.string().optional(),
  isSyntheticVerification: z.boolean().optional(),
});

export const readOutputSchema = z.object({
  content: z.string().optional(),
});

export const lsOutputSchema = z.object({
  entries: z.string().optional(),
});

export const productSearchOutputSchema = z.object({
  products: z
    .array(
      productSchema.pick({
        title: true,
        id: true,
        description: true,
      }),
    )
    .optional(),
});

export const integrationConfigOutputSchema = z.object({
  integrationType: z.string().optional(),
  integrationConfig: z.any().optional(),
  integrationPrompt: z.string().optional(),
});

export const suggestTemplatesOutputSchema = z.object({
  suggestedTemplateIds: z.array(z.string()).optional(),
  selectedTemplateId: z.string().optional(),
});

export const generatePageOutputSchema = z.object({
  jobId: z.string().optional(),
  publicAccessToken: z.string().optional(),
  createdPageId: z.string().optional(),
  fileVersionId: z.string().optional(),
  // TODO (Ben, 2025-10-22, REPL-20259): See if we can remove this field since it's not used anywhere
  triggerJobType: z.string().optional(),
  error: z.string().optional(),
  isCompleted: z.boolean().optional(),
  pageName: z.string().optional(),
});

export const inspirationOutputSchema = z.object({
  imageUrl: z.string().optional(),
});

export const urlOutputSchema = z.object({
  urlToolResult: z.string().optional(),
  runId: z.string().optional(),
});

export const globOutputSchema = z.object({
  matches: z.string().optional(),
  matchCount: z.number().optional(),
  isTruncated: z.boolean().optional(),
});

export const grepOutputSchema = z.object({
  results: z.string().optional(),
  matchCount: z.number().optional(),
  filesSearched: z.number().optional(),
  isTruncated: z.boolean().optional(),
});
